const defaultColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    enableRowGroup: true,
};

const initialState = {
    rowData: [],
    schemaNames: [],
    columnDefinitions: [],
    reconGraphSummaryRecords: [],
    gridOptions: {
        defaultColDef,
        columnDefs: [],
        enableRangeSelection: true,
        animateRows: true,
        allowContextMenuWithControlKey: true,
        rowGroupPanelShow: 'always',
    },
    contextMenuItems: [],
    agGridTrades: [],
    tradeHistoryRowData: [],
    tradeChildHistoryRowData: [],
};

export default initialState;
